import onload from "./utils/onload";
import post from "./components/post";
import sharer from "./components/sharer";

onload(() => {
    post();
    sharer();
});
